// Hook réutilisable pour charger une liste configurable depuis metier_config_listes
// Usage: const { items, loading } = useConfigList("civilites");
import { useState, useEffect } from "react";

const API = process.env.REACT_APP_BACKEND_URL;
const cache = {};

export function useConfigList(listType) {
  const tenantId = localStorage.getItem("current_tenant_slug") || "default";
  const cacheKey = `${tenantId}__${listType}`;

  const [items, setItems] = useState(cache[cacheKey] || []);
  const [loading, setLoading] = useState(!cache[cacheKey]);

  useEffect(() => {
    const tenantId = localStorage.getItem("current_tenant_slug") || "default";
    const cacheKey = `${tenantId}__${listType}`;
    if (cache[cacheKey]) { setItems(cache[cacheKey]); setLoading(false); return; }
    let cancelled = false;
    const load = async () => {
      try {
        const token = localStorage.getItem("session_token");
        const res = await fetch(`${API}/api/metier/config-listes/${listType}`, {
          headers: { ...(token && { Authorization: `Bearer ${token}` }) },
          credentials: "include"
        });
        if (res.ok && !cancelled) {
          const data = await res.json();
          const list = data.items || [];
          cache[cacheKey] = list;
          setItems(list);
        }
      } catch (e) {
        console.error(`useConfigList(${listType}):`, e);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => { cancelled = true; };
  }, [listType]);

  return { items, loading };
}

// Helper: transforme les items en options pour un <Select>
export function listToOptions(items) {
  return items.map(i => ({ value: i.id, label: i.label }));
}

// Helper: résout le label d'un id depuis une liste config (metier_config_listes),
// avec repli sur la valeur hard-codée actuelle si la liste n'est pas (encore)
// chargée / seedée → zéro régression. Source unique du wiring "enum → label".
export function configLabel(items, id, fallback) {
  const list = Array.isArray(items) ? items : [];
  const item = list.find(i => (i.id ?? i.value) === id);
  return (item && item.label) || fallback;
}
